import { render } from "./ProveedorList.vue?vue&type=template&id=864a20da&scoped=true"
import script from "./ProveedorList.vue?vue&type=script&lang=js"
export * from "./ProveedorList.vue?vue&type=script&lang=js"

import "./ProveedorList.vue?vue&type=style&index=0&id=864a20da&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864a20da"]])

export default __exports__